import { render, staticRenderFns } from "./Grid-ranking-center.vue?vue&type=template&id=0fe37954&scoped=true&lang=pug"
import script from "./Grid-ranking-center.vue?vue&type=script&lang=js"
export * from "./Grid-ranking-center.vue?vue&type=script&lang=js"
import style0 from "./Grid-ranking-center.vue?vue&type=style&index=0&id=0fe37954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe37954",
  null
  
)

export default component.exports